export default {
    "order_record": "訂單紀錄",
    "order_detail": "訂單明細",
    "order_all": "全部",
    "order_unpaid": "未付款",
    "service_action_inbound": "入窖",
    "service_action_outbound": "出窖",
    "service_action_storage": "窖藏中",
    "payment_status_payment_failed": "扣款失敗",
    "payment_status_expired": "已逾期",
    "payment_status_paid": "付款成功",
    "payment_status_unpaid": "未付款",
    "patment_status_failed": "付款失敗",
    "storage_record": "存放紀錄",
    "take_out_record": "領出紀錄",
    "order_search_placeholder": "用酒名，關鍵字搜尋訂單",
    "item": "項目",
    "status": "狀態",
    "invoice": "發票",
    "invoice_type": "發票種類",
    "description": "敘述",
    "total_amount": "總計",
    "paid": "已付",
    "unpaid": "未付",
    "payment_info": "付款資訊",
    "debit_date": "扣款日期",
    "inbound_fee": "入窖費用",
    "outbound_fee": "出窖費用",
    "storage_fee": "窖藏儲存費",
    "user_info": "用戶資訊",
    "fee_datail": "使用紀錄明細",
    "fee_item": "品項",
    "amount": "數量",
    "credit_card_last_four": "信用卡後四碼",
    "debit_Succ": "扣款成功",
    "debit_fail": "扣款失敗",
    "download_invoice_PDF": "下載 Invoice PDF",
    "download_order_wines_detail": "下載訂單酒款明細"
}